/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    validationData: {
      type: Object,
      default() {
        return {
          isValid: null,
        };
      },
    },
    value: {
      type: [Object, Array, String],
      default: null,
    },
    extraInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
};
